module.exports = __webpack_public_path__ + "static/media/ic-account-added.1b138e37.svg";